<template>
    <div class="logout">
        <h1>LOGOUT Page done</h1>
    </div>
</template>

<script>
    export default {
        name: "LogOut"
    }
</script>

<style scoped>

</style>